import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ErrorsService } from '../../errors/errors-service/errors.service';
import { BrowserPlatformService } from '../browser-platform/browser-platform.service';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    private _errorsService = inject(ErrorsService);
    private _browser = inject(BrowserPlatformService);

    public sendEvent(category: string = '', action: string = ''): void {
        const win = this._browser.nativeWindow as (Window & { gtag?: (...args: unknown[]) => void }) | null;
        if (!win) {
            return;
        }

        try {
            if (win.gtag) {
                win.gtag('event', category, {
                    operation: action,
                    content_group: win.location.pathname.match(/^\/[^\/]*/)?.[0],
                });
            }
        } catch (error) {
            if (environment.production) {
                this._errorsService.log(error);
            }
        }
    }

    public page_view(title: string) {
        const win = this._browser.nativeWindow as (Window & { gtag?: (...args: unknown[]) => void }) | null;
        if (win?.gtag) {
            win.gtag('event', 'page_view', {
                page_title: title,
                content_group: win.location.pathname.match(/^\/[^\/]*/)?.[0],
            });
        }
    }
}
